const getPastDateAndTime = (dateString) => {
    

    //! seferde 2024-10-19T11:20:09.7079360Z
    //! tamamlanan 2024-10-19T08:26:22.8002843
    
    const date = new Date(dateString);

    if(dateString){

        // Türkiye saatine göre +3 saat ekle
        // date.setHours(date.getHours() + 3);
        
        // Şimdiki tarih ve saat (yerel zaman)
        const now = new Date();
        
        // Bugünün tarihini al (saat, dakika ve saniyeleri sıfırla)
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        
        // Dünün tarihini al
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        
        // Tarih karşılaştırması yap
        let formattedDate;
        if (date >= today) {
            // Tarih bugün ise null döndür
            formattedDate = null;
        } else if (date >= yesterday && date < today) {
            // Tarih dün ise "Dün" yaz
            formattedDate = "Dün";
        } else {
            formattedDate = new Intl.DateTimeFormat('tr-TR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })?.format(date);
        }
        
    // Zamanı formatla
    const formattedTime = new Intl.DateTimeFormat('tr-TR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    })?.format(date);

    return {
        formattedDate,
        formattedTime
    }

    }

    else{
        return {
            formattedDate: null,
            formattedTime: null
        }
    }

}

export default getPastDateAndTime